// ResourcesModal specific
export const DIRECTORY_STATUS_FIELD_ID = "cDiwaCpf0NEsz0IbDW57";
export const COUNTRIES_API_URL =
  "https://restcountries.com/v3.1/all?fields=name";

export const MODAL_TITLE = "Online Member Directory";
export const SAVE_BTN_TEXT = "Submit";
export const CANCEL_BTN_TEXT = "Cancel";

export const DISCLAIMERS = [
  "*Submit the form to be listed in the members directory after approval.",
  "*All updates submitted through this form must be reviewed and approved by an administrator before they appear.",
  "*Approved changes may take up to 24 hours to display.",
  "* You can submit updates at any time. When you do, your new data will replace the old data in that field.",
  "*Fields you do not change will remain the same.",
];

export const STATUS_LABEL = "Member Directory Status:";
export const STATUS_APPROVED = "Approved";
export const STATUS_PENDING = "Pending";

export const LABEL_BACKGROUND_PICTURE = "Your Background Picture";

// Address fields
export const LABEL_STREET_ADDRESS = "Street Address";
export const LABEL_CITY = "City";
export const LABEL_STATE = "State";
export const LABEL_COUNTRY = "Country";
export const LABEL_POSTAL_CODE = "Postal Code";
export const PLACEHOLDER_COUNTRY = "Select a country";

const ADDRESS_PLACEHOLDER = "Enter your practice or mailing address...";

export const ADDRESS_FIELDS = [
  {
    name: "streetAddress",
    label: LABEL_STREET_ADDRESS,
    placeholder: ADDRESS_PLACEHOLDER,
  },
  { name: "city", label: LABEL_CITY, placeholder: ADDRESS_PLACEHOLDER },
  { name: "state", label: LABEL_STATE, placeholder: ADDRESS_PLACEHOLDER },
  {
    name: "postalCode",
    label: LABEL_POSTAL_CODE,
    placeholder: ADDRESS_PLACEHOLDER,
  },
];
